import {useParams} from '@aboutyou/router';

export const useBrandDiscoverIdentifier = () => {
  const {brandId} = useParams<{brandId?: string}>();

  const id = Number(brandId);

  if (!isNaN(id)) {
    return {
      $case: 'id' as const,
      id,
    };
  }

  // could not find any valid id
  return {
    $case: 'id' as const,
    id: -1,
  };
};
